import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

interface RoleUser {
  _id: string;
  name: string;
  email: string;
  role: string;
  isActive: boolean;
}

type RoleUsersMap = Record<string, string>;

export function useRoleUsers() {
  const { user } = useAuth();
  const [roleUsers, setRoleUsers] = useState<RoleUsersMap>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // /api/users AdminGuard ile korunuyor — non-admin rollerde istek atma, 403 üretme.
    if (user?.role !== 'admin') {
      setLoading(false);
      return;
    }

    const loadUsers = async () => {
      try {
        const response = await axios.get('/users');
        const users: RoleUser[] = response.data || [];

        const activeUsers = users.filter((u) => u.isActive);

        const map: RoleUsersMap = {};
        const roleGroups: Record<string, string[]> = {};

        activeUsers.forEach((u) => {
          if (!roleGroups[u.role]) {
            roleGroups[u.role] = [];
          }
          const firstName = u.name.split(' ')[0];
          if (!roleGroups[u.role].includes(firstName)) {
            roleGroups[u.role].push(firstName);
          }
        });

        Object.entries(roleGroups).forEach(([role, names]) => {
          map[role] = names.join(', ');
        });

        setRoleUsers(map);
      } catch (error) {
        console.warn('Kullanıcı isimleri yüklenemedi, boş kalacak');
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, [user?.role]);

  const getUsersByRole = (role: string): string => {
    return roleUsers[role] || '';
  };

  return { roleUsers, getUsersByRole, loading };
}
